"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicCoreHarnessFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "action",
                type: "string",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "pauseState",
                type: "bool",
            },
        ],
        name: "ActionPaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "action",
                type: "string",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "pauseState",
                type: "bool",
            },
        ],
        name: "ActionPaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "currentBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lastBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicTokens",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "currentAmount",
                type: "uint256",
            },
        ],
        name: "CollectVaultReward",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicBorrowIndex",
                type: "uint256",
            },
        ],
        name: "DistributedBorrowerTonic",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicSupplyIndex",
                type: "uint256",
            },
        ],
        name: "DistributedSupplierTonic",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "error",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "info",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "detail",
                type: "uint256",
            },
        ],
        name: "Failure",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "MarketEntered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "MarketExited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "MarketListed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBorrowCap",
                type: "uint256",
            },
        ],
        name: "NewBorrowCap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldBorrowCapGuardian",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newBorrowCapGuardian",
                type: "address",
            },
        ],
        name: "NewBorrowCapGuardian",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldCloseFactorMantissa",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newCloseFactorMantissa",
                type: "uint256",
            },
        ],
        name: "NewCloseFactor",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldCollateralFactorMantissa",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newCollateralFactorMantissa",
                type: "uint256",
            },
        ],
        name: "NewCollateralFactor",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldLiquidationIncentiveMantissa",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newLiquidationIncentiveMantissa",
                type: "uint256",
            },
        ],
        name: "NewLiquidationIncentive",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPauseGuardian",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPauseGuardian",
                type: "address",
            },
        ],
        name: "NewPauseGuardian",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract PriceOracle",
                name: "oldPriceOracle",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract PriceOracle",
                name: "newPriceOracle",
                type: "address",
            },
        ],
        name: "NewPriceOracle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "TonicBorrowSpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TonicGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "TonicSupplySpeedUpdated",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TectonicSocket",
                name: "unitroller",
                type: "address",
            },
        ],
        name: "_become",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "_borrowGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "_grantTonic",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "_mintGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newBorrowCapGuardian",
                type: "address",
            },
        ],
        name: "_setBorrowCapGuardian",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "bool",
                name: "state",
                type: "bool",
            },
        ],
        name: "_setBorrowPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "newCloseFactorMantissa",
                type: "uint256",
            },
        ],
        name: "_setCloseFactor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "newCollateralFactorMantissa",
                type: "uint256",
            },
        ],
        name: "_setCollateralFactor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "newLiquidationIncentiveMantissa",
                type: "uint256",
            },
        ],
        name: "_setLiquidationIncentive",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "newBorrowCaps",
                type: "uint256[]",
            },
        ],
        name: "_setMarketBorrowCaps",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "newSupplyCap",
                type: "uint256",
            },
        ],
        name: "_setMarketSupplyCap",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "bool",
                name: "state",
                type: "bool",
            },
        ],
        name: "_setMintPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newPauseGuardian",
                type: "address",
            },
        ],
        name: "_setPauseGuardian",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract PriceOracle",
                name: "newOracle",
                type: "address",
            },
        ],
        name: "_setPriceOracle",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "state",
                type: "bool",
            },
        ],
        name: "_setSeizePaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "supplySpeeds",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "borrowSpeeds",
                type: "uint256[]",
            },
        ],
        name: "_setTonicSpeeds",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "state",
                type: "bool",
            },
        ],
        name: "_setTransferPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "_supportMarket",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accountAssets",
        outputs: [
            {
                internalType: "contract TToken",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "accountLookup",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "adminModule",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "allMarkets",
        outputs: [
            {
                internalType: "contract TToken",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "blockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "borrowAmount",
                type: "uint256",
            },
        ],
        name: "borrowAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "borrowCapGuardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "borrowCaps",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "borrowGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "checkMembership",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "claimTokenHelper",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "claimTonic",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "contract TToken[]",
                name: "tTokens",
                type: "address[]",
            },
        ],
        name: "claimTonic",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "closeFactorMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "collectTonicToVault",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "deferLiquidityCheck",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
        ],
        name: "enterMarkets",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tTokenAddress",
                type: "address",
            },
        ],
        name: "exitMarket",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountLiquidity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountLiquidityAndTotalBorrow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAllMarkets",
        outputs: [
            {
                internalType: "contract TToken[]",
                name: "",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAssetsIn",
        outputs: [
            {
                internalType: "contract TToken[]",
                name: "",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "tTokenModify",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "redeemTokens",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrowAmount",
                type: "uint256",
            },
        ],
        name: "getHypotheticalAccountLiquidity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getTonicAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getTonicMarkets",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
        ],
        name: "harnessAddTonicMarkets",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "marketBorrowIndexMantissa",
                type: "uint256",
            },
        ],
        name: "harnessDistributeAllBorrowerTonic",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "harnessDistributeAllSupplierTonic",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "marketBorrowIndexMantissa",
                type: "uint256",
            },
        ],
        name: "harnessDistributeBorrowerTonic",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "harnessDistributeSupplierTonic",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "blocks",
                type: "uint256",
            },
        ],
        name: "harnessFastForward",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "harnessRefreshTonicSpeeds",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "tonicRate_",
                type: "uint256",
            },
        ],
        name: "harnessSetTonicRate",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "userAccrued",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "threshold",
                type: "uint256",
            },
        ],
        name: "harnessTransferTonic",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "marketBorrowIndexMantissa",
                type: "uint256",
            },
        ],
        name: "harnessUpdateTonicBorrowIndex",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
        ],
        name: "harnessUpdateTonicSupplyIndex",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "isDeprecated",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isTectonicCore",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastContributorBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "tTokenCollateral",
                type: "address",
            },
            {
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
        ],
        name: "liquidateBorrowAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "tTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "tTokenCollateral",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "actualRepayAmount",
                type: "uint256",
            },
        ],
        name: "liquidateCalculateSeizeTokens",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "liquidationIncentiveMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "liquidityCheckWhiteList",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "markets",
        outputs: [
            {
                internalType: "bool",
                name: "isListed",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "collateralFactorMantissa",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isTonicized",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "maxAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "minter",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "mintAmount",
                type: "uint256",
            },
        ],
        name: "mintAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "mintGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract PriceOracle",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pauseGuardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingTectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "redeemer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "redeemTokens",
                type: "uint256",
            },
        ],
        name: "redeemAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "redeemer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "redeemAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "redeemTokens",
                type: "uint256",
            },
        ],
        name: "redeemVerify",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "payer",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
        ],
        name: "repayBorrowAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tTokenCollateral",
                type: "address",
            },
            {
                internalType: "address",
                name: "tTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "seizeTokens",
                type: "uint256",
            },
        ],
        name: "seizeAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "seizeGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_adminModule",
                type: "address",
            },
        ],
        name: "setAdminModule",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "number",
                type: "uint256",
            },
        ],
        name: "setBlockNumber",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_claimTokenHelper",
                type: "address",
            },
        ],
        name: "setClaimTokenHelper",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address[]",
                name: "callers",
                type: "address[]",
            },
            {
                internalType: "bool[]",
                name: "licences",
                type: "bool[]",
            },
        ],
        name: "setLiquidityCheckWhiteList",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "harnessedPauseGuardian",
                type: "address",
            },
        ],
        name: "setPauseGuardian",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tokenRewarderAddress",
                type: "address",
            },
        ],
        name: "setTokenRewarder",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "userAccrued",
                type: "uint256",
            },
        ],
        name: "setTonicAccrued",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tonicAddress_",
                type: "address",
            },
        ],
        name: "setTonicAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "blockNumber_",
                type: "uint32",
            },
        ],
        name: "setTonicBorrowState",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "setTonicBorrowerIndex",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "setTonicSupplierIndex",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "blockNumber_",
                type: "uint32",
            },
        ],
        name: "setTonicSupplyState",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "vaultAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tonicSpeed",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tonicCap",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "initialSupply",
                type: "uint256",
            },
        ],
        name: "setVaultReward",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "supplyCaps",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicCoreVersion",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicVaultContract",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tokenRewarderAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenToPerUserTvlProtectLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicAccrued",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowState",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowerIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicContributorSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicInitialIndex",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplierIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplySpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplyState",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultAmountCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultLastBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultSpeed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "transferTokens",
                type: "uint256",
            },
        ],
        name: "transferAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "transferGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "contract TToken[]",
                name: "tTokens",
                type: "address[]",
            },
        ],
        name: "updateTonicAccruedForUser",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "utilizedTvlAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "whitelistProtectEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "whitelistedAddresses",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class TectonicCoreHarnessFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicCoreHarnessFactory = TectonicCoreHarnessFactory;
TectonicCoreHarnessFactory.bytecode = _bytecode;
TectonicCoreHarnessFactory.abi = _abi;
//# sourceMappingURL=TectonicCoreHarnessFactory.js.map